import { render, staticRenderFns } from "./app-page-footer.vue?vue&type=template&id=0f88603b&scoped=true&"
import script from "./app-page-footer.vue?vue&type=script&lang=js&"
export * from "./app-page-footer.vue?vue&type=script&lang=js&"
import style0 from "./app-page-footer.vue?vue&type=style&index=0&id=0f88603b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88603b",
  null
  
)

export default component.exports